import React, { Component } from "react";
import { Subscribe } from "unstated";
import { withTranslation } from "react-i18next";

import StateContainer from "../../state/StateContainer";
import DisplayWrapper from "../DisplayWrapper/DisplayWrapper";
import StarButton from "../Buttons/StarButton/StarButton";
import BackButton from "../Buttons/BackButton/BackButton";
import ToggleApartmentView from "../ToggleApartmentView/ToggleApartmentView";

import stringHelper from "../../utils/helpers/stringHelper";
import deviceHelper from "../../utils/helpers/deviceHelper";
import labelHelper from "../../utils/helpers/labelHelper";

import "./ApartmentSidebar.css";

class ApartmentSidebar extends Component {
  state = {
    buttonImgUrl: null,
    isMobile: deviceHelper.isMobileDevice(),
  };

  /**
   * Dispatches event to add/remove apartments from favourites and sets a value used for
   * displaying the favourite button background.
   * @param favouriteApartments
   * @param apartmentClickedInfo
   */
  handleFavouriteClick(favouriteApartments, apartmentClickedInfo) {
    const apartmentKey = apartmentClickedInfo.key;

    if (favouriteApartments.includes(apartmentKey)) {
      let event = new CustomEvent("removeFavourite", {
        detail: {
          key: apartmentKey,
        },
      });

      window.dispatchEvent(event);

      this.setState({ buttonImgUrl: true });
      return;
    }

    this.setState({ buttonImgUrl: false });

    let event = new CustomEvent("addFavourite", {
      detail: {
        key: apartmentKey,
      },
    });

    window.dispatchEvent(event);
  }

  /**
   * Returns favourite button background image url depending on whether the apartment is already favourited or not.
   * @param favouriteApartments Array of favourite apartment keys
   * @param apartmentClickedKey Key of clicked apartment
   */
  getFavouriteButtonBackground(favouriteApartments, apartmentClickedKey) {
    if (favouriteApartments.includes(apartmentClickedKey)) {
      return "design/new-exports/Star_with_minus.png";
    }
    return "design/new-exports/Star_with_plus.png";
  }

  getFontSize(text) {
    if (text.length > 3) {
      return "16px";
    }
    if (text.length > 1) {
      return "27px";
    }
    return "40px";
  }

  render() {
    const { t } = this.props;
    const { facingSide } = this.props.unstated.state.apartmentClickedInfo;
    const { type } = this.props.unstated.state.apartmentClickedInfo;
    const hotspotType = this.props.unstated.state.apartmentClickedInfo.isReserved ? "RESERVED" : type;
    const labelText = this.props.unstated.state.hotspots[hotspotType].text;
    const priceFormatting = labelHelper.getPriceFormatting(this.props.unstated.state.apartmentClickedInfo, true);

    return (
      <div className="apartmen__sidebar--container">
        {this.state.isMobile && (
          <>
            <button
              className="apartment__sidebar-favourite-button"
              style={{
                backgroundImage: `Url(${this.getFavouriteButtonBackground(
                  this.props.unstated.state.favouriteApartments,
                  this.props.unstated.state.apartmentClickedInfo.key
                )})`,
              }}
              onClick={() => {
                this.handleFavouriteClick(
                  this.props.unstated.state.favouriteApartments,
                  this.props.unstated.state.apartmentClickedInfo
                );
              }}
            />

            <div className="apartment__sidebar_2d-3d_wrap">
              <ToggleApartmentView />
            </div>
            <div className="apartment_back-button">
              <div className="apartmentInfo__button-wrapper">
                <BackButton
                  frameId={this.state.frameId}
                  isApartmentPage={true}
                />
              </div>
            </div>
          </>
        )}
        <div
          className="side__menu--logo_container sidebar__logo-wrap"
          style={{
            backgroundColor: stringHelper.removeAplhaFromColor(
              this.props.unstated.state.menuColor
            ),
          }}
        >
          <div className="logo-wrap sidebar__logo-wrap">
            <div
              className="side__menu--logo"
              style={{
                backgroundImage: `Url(${this.props.unstated.state.projectLogo
                    ? this.props.unstated.state.projectLogo
                    : ""
                  })`,
              }}
            ></div>
            <div className="side"></div>
            <div className="side__menu-star_icon">
              <StarButton />
            </div>
          </div>
          <DisplayWrapper displayParameter="isInvestorLogoShown">
            <div
              className="side__menu--image client-image"
              style={{
                backgroundImage: `Url(${this.props.unstated.state.clientLogo})`,
              }}
            ></div>
          </DisplayWrapper>
        </div>
        <div
          className="sidebar__left"
          style={{
            backgroundColor: this.props.unstated.state.menuColor,
          }}
        >
          <div className="apartment__name">
            <img
              src="/design/new-exports/template.png"
              alt="apartment thumbnail"
              className="sidebar__logo-wrap"
            />
            <div className="apt-container">
              <span className="apt">{t("APARTMENT")}</span>
              <span
                style={{
                  color:
                    this.props.unstated.state.hotspots[hotspotType].defaultColor,
                }}
                className="apt-num"
              >
                {this.props.unstated.state.apartmentClickedInfo.name}
              </span>
            </div>
          </div>
          <div className="apartment__info">
            <div className="apartment__info-row">
              <div className="apartment__info-row-item">
                <div
                  className={`${type.toLowerCase()}-icon`}
                  style={{
                    backgroundColor:
                      this.props.unstated.state.hotspots[hotspotType].defaultColor,
                  }}
                ></div>
              </div>
              <div className="apartment__info-row-item">
                <span className="t2">{labelText || t(type)}</span>
                {!labelText && (
                  <>
                    <span> {t("APARTMENT").toLowerCase()}</span>
                    <span>
                      {labelHelper.getHotspotLongTypeTranslation(type)}
                    </span>
                  </>
                )}
              </div>
            </div>
            <div className="apartment__info-row">
              <div className="apartment__info-row-item">
                <span>{t("SURFACE")}</span>
                <span>{t("HABITABLE").toLowerCase()}</span>
              </div>
              <div className="apartment__info-row-item">
                <span>
                  <b>
                    {this.props.unstated.state.apartmentClickedInfo.quadrature}{" "}
                    ㎡
                  </b>
                </span>
              </div>
            </div>
            {this.props.unstated.state.apartmentClickedInfo
              .ponderee ? (
              <div className="apartment__info-row">
                <div className="apartment__info-row-item">
                  <span>Pondérée</span>
                </div>
                <div className="apartment__info-row-item">
                  <span>
                    <b>
                      {
                        this.props.unstated.state.apartmentClickedInfo
                          .ponderee
                      }{" "}
                      ㎡
                    </b>
                  </span>
                </div>
              </div>
            ) : null}
            {this.props.unstated.state.apartmentClickedInfo
              .terraceQuadrature ? (
              <div className="apartment__info-row">
                <div className="apartment__info-row-item">
                  <span>{t("TERRACE")}</span>
                </div>
                <div className="apartment__info-row-item">
                  <span>
                    <b>
                      {
                        this.props.unstated.state.apartmentClickedInfo
                          .terraceQuadrature
                      }{" "}
                      ㎡
                    </b>
                  </span>
                </div>
              </div>
            ) : null}
            <div className="apartment__info-row">
              <div className="apartment__info-row-item">
                <span>{t("ORITENTATION")}</span>
              </div>
              <div className="apartment__info-row-item">
                <span>{t(facingSide)}</span>
              </div>
            </div>
            <div className="apartment__info-row">
              <div className="apartment__info-row-item">{t("BATHROOM")}</div>
              <div className="apartment__info-row-item">
                <span>
                  <b>
                    {this.props.unstated.state.apartmentClickedInfo.bathrooms}
                  </b>
                </span>
              </div>
            </div>
            {this.props.unstated.state.apartmentClickedInfo
              .showApartmentPrice ? (
              <div className="apartment__info-row">
                <div className="apartment__info-row-item">{t("PRICE")}</div>
                <div className="apartment__info-row-item">
                  <span>
                    <b style={{ fontSize: priceFormatting.fontSize }}>
                      {priceFormatting.text}
                    </b>
                  </span>
                </div>
              </div>
            ) : null}
          </div>
          <div className="apartment__map"></div>
        </div>

        <div className="sidebar__right">
          <div
            className="top__section"
            style={{
              backgroundColor: this.props.unstated.state.menuColor,
            }}
          >
            <button
              className="apartment__sidebar-favourite-button"
              style={{
                backgroundImage: `Url(${this.getFavouriteButtonBackground(
                  this.props.unstated.state.favouriteApartments,
                  this.props.unstated.state.apartmentClickedInfo.key
                )})`,
              }}
              onClick={() => {
                this.handleFavouriteClick(
                  this.props.unstated.state.favouriteApartments,
                  this.props.unstated.state.apartmentClickedInfo
                );
              }}
            />
          </div>
          <div className="apartment__floor">
            <p>
              {t("STAGE").toUpperCase()}
              <br />
              <span
                style={{
                  fontSize: this.getFontSize(
                    stringHelper.parseStateNumber(
                      this.props.unstated.state.jsonData.states[
                        this.props.unstated.state.currentState
                      ].name
                    )
                  ),
                }}
              >
                {stringHelper.parseStateNumber(
                  this.props.unstated.state.jsonData.states[
                    this.props.unstated.state.currentState
                  ].name
                )}
              </span>
            </p>
          </div>
          <div
            className="bottom__section"
            style={{
              backgroundColor: this.props.unstated.state.menuColor,
            }}
          ></div>
        </div>

        <div
          className="house__image"
          style={{
            backgroundImage: `Url(${this.props.unstated.state.jsonData.states[
                this.props.unstated.state.currentState
              ].rows[this.props.unstated.state.currentRow].highResUrls[
              this.props.unstated.state.currentColumn
              ]
              })`,
          }}
        ></div>
      </div>
    );
  }
}

function ApartmentSidebarWithUnstated(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <ApartmentSidebar {...props} unstated={unstated} />}
    </Subscribe>
  );
}

export default withTranslation()(ApartmentSidebarWithUnstated);
